<template>
  <div id="app">
  <header>
     <div class="whidth-container">  
        <div class="logo-container"><span>dj</span><span>pipeline</span></div>
        <div class="flex-group menusContainer">
            <div class="search-container" role="form">
            <button class='titanic titanic-search-close searchBTN'></button>
                <div class="search-expand hidden " aria-expanded="false">
                    <div class="flex-group search-wrapper">
                        <label for="search_input" class="for-screenReader">search</label>
                        <input id="search_input" v-model="searchTerm" v-on:keyup.enter="search(searchTerm, collection, searchField)" class="search-input" placeholder="search">
                        <div class="icon-holder">
                          <button v-on:click="search(searchTerm, collection, searchField)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" preserveAspectRatio="xMidYMid meet" style="width: 100%; height: 100%;"><defs><clipPath id="animationMask_nZ7p4ccoBX"><rect width="50" height="50" x="0" y="0"></rect></clipPath></defs><g clip-path="url(#animationMask_nZ7p4ccoBX)"><g transform="matrix(1,0,0,1,0,0)" opacity="1" style="user-select: none;"><g opacity="1" transform="matrix(1,0,0,1,21,20)"><path stroke-linecap="round" stroke-linejoin="miter" fill-opacity="0" stroke-miterlimit="10" stroke="rgb(0,0,0)" stroke-opacity="1" stroke-width="2" d=" M0,-16 C8.837,-16 16,-8.837 16,0 C16,8.837 8.837,16 0,16 C-8.837,16 -16,8.837 -16,0 C-16,-8.837 -8.837,-16 0,-16z"></path></g><g opacity="1" transform="matrix(1,0,0,1,38.865,38.865)"><path stroke-linecap="butt" stroke-linejoin="miter" fill-opacity="0" stroke-miterlimit="10" stroke="rgb(0,0,0)" stroke-opacity="1" stroke-width="4" d=" M-6.635,-6.635 C-6.635,-6.635 6.635,6.635 6.635,6.635"></path></g></g><g style="user-select: none; display: none;"><g><path stroke-linecap="round" stroke-linejoin="miter" fill-opacity="0" stroke-miterlimit="10" style="display: none;"></path></g><g><path stroke-linecap="butt" stroke-linejoin="miter" fill-opacity="0" stroke-miterlimit="10" style="display: none;"></path></g></g><g style="user-select: none; display: none;"><g><path stroke-linecap="butt" stroke-linejoin="miter" fill-opacity="0" stroke-miterlimit="10" style="display: none;"></path></g></g><g style="user-select: none; display: none;"><g><path stroke-linecap="round" stroke-linejoin="miter" fill-opacity="0" stroke-miterlimit="10" style="display: none;"></path></g></g><g style="user-select: none; display: none;"><g><path stroke-linecap="round" stroke-linejoin="miter" fill-opacity="0" stroke-miterlimit="10" style="display: none;"></path></g></g></g></svg>
                          </button>
                        </div>
                    </div>
                    <div class="filter-container">
                        <p>Sort By:</p>
                        <div class="track-tags">
                            <button class="tag style">Genre</button>
                            <button class="tag key">Key</button>
                            <button class="tag bpm">bpm</button>
                        </div>
                      </div>
                </div>
            </div>

            <div class="menu-container">
                <button class='titanic titanic-menu-minus menuBTN' title="open menu"></button>

                <div class="menu-expand hidden" aria-expanded="false">
                    <nav>
                        <ul>
                            <li><a href="" class="menu-item">about DJPipeLine</a></li>
                            <li><a href="" class="menu-item">contact us</a></li>
                        </ul>
                    </nav>
                </div>
            </div>
                  <button style="color:#ff7500" class="btn btn-danger log" v-show="$auth.isAuthenticated" @click="logout">Log out </button>
                  <button style="color:#ff7500" class="btn btn-info log" v-show="!$auth.isAuthenticated" @click="login">Log In</button>
        </div>
    </div> 
</header>
<main>
  <router-view/>
    <section class="trackList-container">
        <div class="list-sortBy">
            <div class="listsSort">
                <label for="list-select" class="for-screenReader">sort by lists</label>
                <select v-model="collection">
                    <option selected>incoming</option>
                    <option>traktor</option>
                </select>
            </div>
            <div class="categorySort">
                <label for="list-select" class="for-screenReader">sort by lists</label>
                <select v-model="sort_by">
                    <option selected>Sort by date</option>
                    <option>Sort by name</option>
                    <option>Sort by source</option>
                    <option>Sort by key</option>
                    <option>Sort by genre</option>
                    <option>Sort by artist</option>
                </select>
            </div>
        </div>
        <div class="sortTitle-container">
            <h2 class="listTitle">{{ collection }}</h2><h3>{{ sort_by }}</h3>
        </div>
        <ul class="track-list">
        <li class="track-unit" v-for="item in items" v-bind:key="item._id">
            <div class="flex-group trackContent">
                <div class="playPause" v-bind:style="trackArtwork(item)"><button class="play-pauseBTN" title="play pause" v-on:click="togglePlayer(item)"><span class="for-screenReader">play music</span></button></div>
                <div class="track-info">
                    <div>
                         <div class="flex-group">
                            <span class="track-name">
                                {{ item.title }}
                            </span>
                            <span class="track-creator">
                                By {{ item.artist }}
                            </span>
                        </div>
                        <div class="track-details">
                            <span class="track-date">
                                added {{ item.timestamp }} from {{ item.source }}
                            </span>
                        </div>
                    </div>

                    <div class="track-tags">
                        <span v-if="item.genre" class="tag style">{{ item.genre }}</span>
                        <span v-if="item.key" class="tag key">Key: {{ item.key }}</span>
                        <span v-if="item.bpm" class="tag bpm">{{ item.bpm }} bpm</span>
                    </div>
                </div>
            </div>
            <div class="track-action">
               <button v-if="item.internal_links" class="linkExistentTrackBTN"><span class="for-screenReader">link for existent track in your list</span></button>
               <template v-else>
                <a class="buyBTN" v-bind:href="item.links.itunes"><span class="buyText">BUY</span><span class="siteNameText">itunes</span></a>
               </template>
                <button class="heartBTN" v-bind:class="{ choosen: item.liked }" title="like" v-on:click="toggleLike(item)"><span class="for-screenReader">like</span></button>
            </div>
        </li>
        </ul>
    </section>
    <section class="player-container" id="player-container">
      <!-- <iframe id="youtube_iframe" width="100%" height="100" src="https://www.youtube-nocookie.com/embed/sc3nplnfPRo?enablejsapi=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe> -->
       <!-- <iframe id="spotify_iframe" src="https://open.spotify.com/embed/track/7kYEEI98YR8fYZFu00hixp" width="100%" height="100" frameborder="0" allowtransparency="true" allow="encrypted-media"></iframe> -->
        <iframe id="sc_iframe" width="100%" height="100" scrolling="no" frameborder="no" allow="autoplay"
        src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/642703401&auto_play=false&hide_related=true&show_comments=false&show_user=false&show_reposts=false&show_teaser=false&visual=false&buying=false&color=%238132a8"></iframe>
    </section>
    <section class="pagination-section">
        <div class="pagination">
            <button class="prev" title="prev" v-on:click="page--"><span class="for-screenReader">previous page</span></button>
            <button v-on:click="page = 0">first</button>
            <button  class="activePage">{{ page + 1 }}</button>
            <button id="last_page_btn" v-on:click="page = last_page">last - {{ last_page+1 }}</button>
            <button class="next" title="next" v-on:click="page++"><span class="for-screenReader">next page</span></button>
          </div>
    </section>
    </main>
  </div>
</template>

<script>
// @ is an alias to /src
import { format } from 'timeago.js';
import { getInstance } from '../auth_plugin';
import axios from 'axios';
import SoundcloudWidget from 'soundcloud-widget';

function process(data) {
  for (let track of data) {
    // timeago format expects milliseconds, while the timestamp is provided in seconds
    track.bpm = Math.round(track.bpm * 1000)/1000;
    // Round bpm to 3 decimal places
    track.timestamp = format(track.timestamp * 1000);
    if (track.source == 'sc_like') {
      track.source = 'Soundcloud';
    }
    else if (track.source == 'my_shazam') {
      track.source = 'Shazam';
    }
    if (track.links.itunes == 'not found') {
      track.links.itunes = '#';
    }
  }
  return(data);
}

function findItem(items, item) {
  for (var i = 0; i < items.length; i++) {
    var track = items[i];
    if (track.id == item.id) {
      return(i);
    }
  }
    return(NaN);
}

const sort_fields = {
  "Sort by date": "timestamp",
  "Sort by name": "id",
  "Sort by source": "source",
  "Sort by genre": "genre",
  "Sort by artist": "artist",
  "Sort by key": "key",
};

const app = {
  name: 'DJPipeline',
  data: function () {
    return {
      items: [],
      //baseUrl: 'http://localhost/',
      baseUrl: 'https://api.djpipeline.com/',
      page: 0,
      page_size: 20,
      collection: "incoming",
      sort_by: 'Sort by date',
      playerStatus: 'stopped',
      currentItemId: NaN,
      trackURL: 'https://api.soundcloud.com/tracks/405748965',
      searchTerm: '',
      last_page: 100,
      searchField: 'id'
    }
  },
  methods: {
    trackArtwork(item) {
      var artworkUrl = item.sc_info && item.sc_info.artwork_url;
      return artworkUrl ? { backgroundImage: `url(${artworkUrl})` } : {};
    },
    login() {
      this.$auth.loginWithRedirect();
    },
    logout() {
      this.$auth.logout({
        returnTo: window.location.origin
      });
    },
    async getAccessToken() {
      try {
        return await this.$auth.getTokenSilently();
      } catch (e) {
        // Session can't be silently renewed (expired/invalid refresh token) -
        // send the user back through Auth0 instead of sending a stale/empty
        // token that the API would just 401 on.
        console.error('getTokenSilently failed, redirecting to login', e);
        this.login();
        return null;
      }
    },
    async getCollection () {
      var field = sort_fields[this.sort_by];
      const access_token = await this.getAccessToken();
      if (!access_token) return;
      axios.get(`${this.baseUrl}page/${this.page}?collection=${this.collection}&page_size=${this.page_size}&raw=true&sort_field=${field}&sort_order=desc`,
      {headers: {
        Authorization: `Bearer ${access_token}`
      }}
        ).then(response => {
          this.items = process(response.data);
        })
        .catch(response => {
          console.log(response);
        });
    },
    async search(term, collection, field) {
      var searchArea = document.getElementsByClassName('search-expand')[0];
      const access_token = await this.getAccessToken();
      if (!access_token) return;
      axios.get(this.baseUrl+"find/" + term + "?collection=" + collection + "&field=" + field + "&raw=true",
      {headers: {
        Authorization: `Bearer ${access_token}`
      }}
      ).then(response => {
          this.items = process(response.data);
          searchArea.classList.add('hidden');
        })
        .catch(response => {
          console.log(response);
          searchArea.classList.add('hidden');
        });
    },
    async getLastPage() {
      //var last_button = document.getElementById('last_page_btn');
      const access_token = await this.getAccessToken();
      if (!access_token) return;
      axios.get(this.baseUrl+"count/" + this.collection,
      {headers: {
        Authorization: `Bearer ${access_token}`
      }}
        ).then(response => {
          this.last_page = Math.floor(response.data/this.page_size);
          //if (response.data % this.page_size > 0) {
          //  this.last_page++;
          //}
        })
        .catch(response => {
          console.log(response);
        });
    },
    async toggleLike(track) {
      var itemIndex = findItem(this.items, track);
      var heartButton = document.getElementsByClassName("heartBTN")[itemIndex]
      var likedBeforePush = heartButton.classList.contains('choosen');
      var data = {'liked': ! likedBeforePush};
      const access_token = await this.getAccessToken();
      if (!access_token) return;
      axios.post(`${this.baseUrl}toggle_like/${this.collection}/${track['_id']}`,
        data,
      {headers: {
        Authorization: `Bearer ${access_token}`
      }}
      )
      .then(response => {return(response)})
      .catch(response => {console.log(response);});
    },
    reloadSCPlayer(track) {
      var trackID = track.sc_info.id;
      if (! trackID) {
        console.log(`No Soundcloud info for ${track['id']}`);
        return
      }
      var trackURL = 'https%3A//api.soundcloud.com/tracks/' + trackID;
      var playerContainer = document.getElementById("player-container");
      var iframe_content = `<iframe id="sc_iframe" width="100%" height="100" scrolling="no" frameborder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=${trackURL}&auto_play=true&hide_related=true&show_comments=false&show_user=false&show_reposts=false&show_teaser=false&visual=false&buying=false&color=%238132a8"></iframe>`
      playerContainer.innerHTML = iframe_content;
      var iframe = document.getElementById("sc_iframe");
      var scPlayer = new SoundcloudWidget(iframe);
      var items = this.items;
      scPlayer.bind(SoundcloudWidget.events.READY, function() {
        scPlayer.bind(SoundcloudWidget.events.PLAY, function() {
          var itemIndex = findItem(items, track);
          var playButton = document.getElementsByClassName("play-pauseBTN")[itemIndex];
          playButton.classList.add('pause')
          this.playerStatus = 'playing';
          this.currentItemId = itemIndex;
          console.log('bound', this.playerStatus);
        });
        scPlayer.bind(SoundcloudWidget.events.PAUSE, function() {
          var itemIndex = findItem(items, track);
          var playButton = document.getElementsByClassName("play-pauseBTN")[itemIndex];
          playButton.classList.remove('pause')
          this.playerStatus = 'stopped';
          this.currentItemId = itemIndex;
          console.log('bound', this.playerStatus);
        });
      });
      return (scPlayer);
    },
    togglePlayer(track) {
      var trackID = track.sc_info.id;
      var trackURL = 'https://api.soundcloud.com/tracks/' + trackID;
      var iframe = document.getElementById("sc_iframe");
      var scPlayer = new SoundcloudWidget(iframe);
      var myApp = this;
      scPlayer.isPaused().then(function (isPaused) {
        if (isPaused) {
          myApp.playerStatus = 'stopped'
          if (trackURL != myApp.trackURL) {
            myApp.reloadSCPlayer(track);
            myApp.trackURL = trackURL;
          }
          else {
            scPlayer.play();
          }
        }
        else {
          myApp.playerStatus = 'playing'
          if (trackURL != myApp.trackURL) {
            //Some track is playing
            //  The user pressed toggle button on a different track
            //  Stop currently playing track and play a new one
            //
            scPlayer.pause();
            var prevPlayButton = document.getElementsByClassName("play-pauseBTN")[myApp.currentItemId];
            prevPlayButton.classList.add('pause')
            var itemIndex = findItem(myApp.items, track);
            var playButton = document.getElementsByClassName("play-pauseBTN")[itemIndex];
            playButton.classList.remove('pause')
            myApp.reloadSCPlayer(track);
            myApp.trackURL = trackURL;
            myApp.currentItemId = itemIndex;
          }
        else {
            scPlayer.pause(); 
          }
        }
      });
   }
  },
  mounted() {
    const instance = getInstance();
    instance.$watch("loading", loading => {
      if (!loading && instance.isAuthenticated) {
        // getAccessToken()/getTokenSilently() re-check freshness and
        // silently renew on every call, so no separate refresh timer is
        // needed here.
        this.getCollection();
        this.getLastPage();
      }
    });
  },
  watch: {
    collection () {
      this.getCollection();
      this.getLastPage();
    },
    page () {
      this.getCollection();
    }
  }
};
export default app
</script>
